import { render, staticRenderFns } from "./sfc-header-slim-student-loans.vue?vue&type=template&id=1486fe1c&scoped=true&lang=pug&"
import script from "./sfc-header-slim-student-loans.vue?vue&type=script&lang=js&"
export * from "./sfc-header-slim-student-loans.vue?vue&type=script&lang=js&"
import style0 from "./sfc-header-slim-student-loans.vue?vue&type=style&index=0&id=1486fe1c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1486fe1c",
  null
  
)

export default component.exports